import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import * as moment from "moment";
import { requestAddNewList } from "../../../../../redux/actions/new-list";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const newListLoading = useSelector(
    (state) => state.newList.createList.loading
  );
  const newListUrl = useSelector((state) => state.newList.apiUrl);
  const newListSize = useSelector((state) => state.newList.listSize.status);
  const newListLocations = useSelector(
    (state) => state.newList.listFilter.locations
  );
  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const [listName, setListName] = useState("");

  const createNewList = () => {
    const newUrl = newListUrl + `&size=${newListSize}`;
    const timestamp = moment(Date.now()).unix();
    const trimmedArea =
      newListLocations && newListLocations.length > 0
        ? newListLocations.join()
        : null;

    if (listName && listName !== "") {
      if (newListSize <= 10000) {
        const listObject = {
          apiLink: newUrl,
          timestamp: timestamp,
          name: listName,
          size: newListSize,
          area: trimmedArea,
        };
        dispatch(requestAddNewList({ list: listObject, company: companyId }));
      } else {
        sendErrorNotification("Listen du prøver å opprette er for stor.");
      }
    } else {
      sendErrorNotification("Du må navngi listen din.");
    }
  };

  return (
    <div className="new-list-form-container">
      <Row className="single-result-row statistics-row">
        <Col className="result-col text-left">
          <Label version={1} weight="bold">
            Navn på liste
          </Label>
          <Input
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            placeholder="Min liste"
            type="text"
          />
        </Col>
        <Col className="result-col button text-right">
          <SolidButton
            color="blue"
            onClick={() => createNewList()}
            icon={
              newListLoading ? (
                <i className="fas fa-circle-notch fa-spin"></i>
              ) : (
                <i className="fas fa-plus"></i>
              )
            }
            title={newListLoading ? "Oppretter.." : "Opprett liste"}
          />
        </Col>
      </Row>
      <hr />
      <ToastContainer />
    </div>
  );
};

export default Index;
